import React from "react";

import QRCode from "../QRCode";

interface IProps {
    /** The data for the QR code. If `undefined`, a spinner is shown. */
    qrCodeBytes: undefined | Uint8ClampedArray;
}

export default class VerificationQRCode extends React.PureComponent<IProps> {
    public render(): React.ReactNode {
        return (
            <QRCode
                data={this.props.qrCodeBytes === undefined ? null : [{ data: this.props.qrCodeBytes, mode: "byte" }]}
                className="mx_VerificationQRCode"
                width={196}
            />
        );
    }
}
